<section class="current-properties-section py-5">
  <div class="container mb-3">
    <app-section-title
      [inital]="title"
      [iscursive]="true"
      [title]="'Upcoming Properties'"
      [subtitle]="'More Destinations for Your Next Mountain Escape'"
    ></app-section-title>
  </div>
  <app-upcoming-property-carousel [upcomingProperties]="upcominghotels"></app-upcoming-property-carousel>
</section>
